import actions from './actions';

const {
    SPL_DASHBOARD_DATA_BEGIN,
    SPL_DASHBOARD_DATA_SUCCESS,
    SPL_DASHBOARD_DATA_ERR,
} = actions;

const initialStateArray = { data: [], loading: false, error: null };

export const splDashboardReducer = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SPL_DASHBOARD_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case SPL_DASHBOARD_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error: null,
                loading: false,
            };
        case SPL_DASHBOARD_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data: null,
                loading: false,
            };
        default:
            return state;
    }
};
